import { render, staticRenderFns } from "./SearchBadgeFilter.vue?vue&type=template&id=3e1e5a61&"
import script from "./SearchBadgeFilter.vue?vue&type=script&lang=js&"
export * from "./SearchBadgeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports